/**
 * Unauthorized Page (403)
 *
 * Shown when user doesn't have permission to access a resource.
 */

import { useNavigate } from 'react-router-dom';
import { ShieldX, ArrowLeft, Home } from 'lucide-react';

import { Button } from '@/components/common/Button';

export function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background dark:bg-background-dark p-4">
      <div className="text-center max-w-md">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="rounded-full bg-danger-50 dark:bg-danger-900/20 p-6">
            <ShieldX className="h-16 w-16 text-danger" />
          </div>
        </div>

        {/* Error code */}
        <h1 className="text-7xl font-bold text-foreground dark:text-foreground-dark mb-2">403</h1>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-foreground dark:text-foreground-dark mb-4">
          Access Denied
        </h2>

        {/* Description */}
        <p className="text-foreground-muted dark:text-foreground-dark-muted mb-8">
          You don&apos;t have permission to access this page. Please contact your administrator if
          you believe this is an error.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            leftIcon={<ArrowLeft className="h-4 w-4" />}
          >
            Go Back
          </Button>
          <Button
            variant="primary"
            onClick={() => navigate('/dashboard')}
            leftIcon={<Home className="h-4 w-4" />}
          >
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
